import React from 'react';
import { MarketingImage } from 'components/MarketingPagesShared/MarketingImage';
import {
  SwitchQuote,
  SwitchQuoteText,
  SwitchQuoteAuthor,
  SwitchQuotePodcast,
} from '../../styles';

export function QuotesId() {
  return (
    <>
      <SwitchQuote>
        <MarketingImage
          imagePath="switch/quotes/localized-assets/id/agak-laen"
          alt="Agak Laen podcast cover"
          width={342}
          height={342}
        />
        <SwitchQuoteAuthor />
        <SwitchQuotePodcast>AGAK LAEN</SwitchQuotePodcast>
        <SwitchQuoteText>
          “Kami memulai podcast dengan Anchor dan ini sangat membantu dalam
          pembuatan dan publikasi podcast kami.”
        </SwitchQuoteText>
      </SwitchQuote>
      <SwitchQuote>
        <MarketingImage
          imagePath="switch/quotes/localized-assets/id/self-dev"
          alt="Self Dev podcast cover"
          width={342}
          height={342}
        />
        <SwitchQuoteAuthor />
        <SwitchQuotePodcast>SelfDev (Pengembangan Diri)</SwitchQuotePodcast>
        <SwitchQuoteText>
          “Saya suka menggunakan Anchor karena sangat nyaman dan semua hanya
          dalam satu klik.”
        </SwitchQuoteText>
      </SwitchQuote>
      <SwitchQuote>
        <MarketingImage
          imagePath="switch/quotes/localized-assets/id/cuma-sharing"
          alt="Cuma Sharing podcast cover"
          width={342}
          height={342}
        />
        <SwitchQuoteAuthor />
        <SwitchQuotePodcast>Cuma Sharing</SwitchQuotePodcast>
        <SwitchQuoteText>
          “Saya suka menggunakan Anchor karena sangat mudah untuk melakukan
          recording dan publikasi podcast saya.”
        </SwitchQuoteText>
      </SwitchQuote>
    </>
  );
}
